import React from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import Lightbox from "yet-another-react-lightbox";
import { useState } from "react";
import {
  Download,
  Fullscreen,
  Thumbnails,
  Video,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./SchoolFacilityPage.css";
import Loader from "../../components/Loader";
import ButtonV2 from "../../components/ButtonV2";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

const SchoolFacilityPage = (props) => {
  // index pro sledovani lightboxu
  const [index, setIndex] = useState(-1);

  // ovladani popupu
  const [showPopup, setShowPopup] = useState(false);

  //fetch dat prislusne stranky jidelna/druzina podle props v App.js (musi se shodovat se strapi api!)
  let populateQuery = "";

  if (props.facility === "canteen-page") {
    populateQuery = `
    populate[contact][populate]=*&populate[background][populate]=*&populate[documents][populate]=*&populate[photos][populate]=*&populate[menu][populate]=*&populate[openingHours][populate]=*
  `;
  } else {
    populateQuery = `
    populate[contact][populate]=*&populate[background][populate]=*&populate[documents][populate]=*&populate[photos][populate]=*&populate[openingHours][populate]=*
  `;
  }
  const { loading, error, data } = useFetch(
    `${config.api}/api/${props.facility}?${populateQuery}`
  );

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání stránky" />;

  if (!data || !data.data) return <DefaultPage message="Žádná data" />;

  // promenná pro lepsi praci s kontaktem
  const contact = data.data.contact;

  //? test
  console.log(data.data);

  //vytvoreni noveho pole pro media z duvodu, ze lightbox potrebuje jiny format JSONU nez jaky dostaneme ze strapi
  //kontrola zdali jsou tam data - jelikoz pole medii je nepovinne
  const galleryData = data?.data?.photos ?? [];
  const mediaEdited = [];

  for (let i = 0; i < galleryData.length; i++) {
    const item = galleryData[i];
    // kontrola nejdulezitejsich hodnot kdyby nahodou byl null
    const mime = item?.mime ?? "";
    const url = item?.url ?? "";
    const mediumUrl = item?.formats?.medium?.url ?? "";
    if (mime.startsWith("image")) {
      mediaEdited.push({
        id: item.id,
        type: "image",
        alternativeText: item.alternativeText,
        src: `${config.api}${url}`,
        medium: `${config.api}${mediumUrl}`,
      });
    } else if (mime.startsWith("video")) {
      mediaEdited.push({
        id: item.id,
        type: "video",
        alternativeText: item.alternativeText,
        title: item.title || "Video Title",
        description: item.description || "Video Description",
        width: 1280, // Adjust as needed
        height: 720, // Adjust as needed
        poster: `/images/video-icon.png`, // default poster
        sources: [
          {
            src: `${config.api}${url}`,
            type: mime,
          },
        ],
      });
    }
  }

  //metody pro ovladani popupu
  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid sub-nav">
        <div className="container d-flex flex-column flex-sm-row align-items-center justify-content-center">
          {data.data?.menu && (
            <a
              href={`${config.api}${data.data.menu.url}`}
              target="blank"
              className="m-2"
            >
              <ButtonV2 text="Jídelníček" />
            </a>
          )}
          {data.data.orderLink && (
            <a href={data.data.orderLink} target="blank" className="m-2">
              <ButtonV2 text="Webové stránky jídelny" />
            </a>
          )}
          {data?.data?.documents &&
            data.data.documents.map((document) => (
              <a
                key={document.id}
                href={`${config.api}${document.url}`}
                target="blank"
                className="m-2"
              >
                <ButtonV2 text={document.name} />
              </a>
            ))}
          {contact && (
            <div onClick={handleButtonClick} className="m-2">
              <ButtonV2 text="Kontakt" />
            </div>
          )}
          {showPopup && (
            <div className="popup">
              <div className="popup-content d-flex flex-column align-items-center">
                <h3>Kontaktní informace</h3>
                {contact?.name && (
                  <p>
                    <b>Jídelna :</b> {contact.name}
                  </p>
                )}
                {contact?.email && (
                  <p>
                    <b>Email :</b> {contact.email}
                  </p>
                )}
                {contact?.phone && (
                  <p>
                    <b>Telefon :</b> {contact.phone}
                  </p>
                )}
                {contact?.address_first_line &&
                  contact?.address_second_line && (
                    <p>
                      <b>Adresa :</b> {contact.address_first_line}{" "}
                      {contact.address_second_line}
                    </p>
                  )}
                {contact?.ico && (
                  <p>
                    <b>IČO :</b> {contact.ico}
                  </p>
                )}
                {contact?.dic && (
                  <p>
                    <b>DIČ :</b> {contact.dic}
                  </p>
                )}
                {contact?.bankAccount && (
                  <p>
                    <b>Bankovní účet :</b> {contact.bankAccount}
                  </p>
                )}
                {contact?.dataBox && (
                  <p>
                    <b>Datová schránka :</b> {contact.dataBox}
                  </p>
                )}
                {contact?.openingHours && contact?.openingHours.length > 0 && (
                  <table className="mt-3">
                    <tbody>
                      {contact.openingHours.map((otvDoba) => (
                        //React fragment misto <></> protoze tomu nejde pridelit key
                        <React.Fragment key={otvDoba.id}>
                          <tr>
                            <td className="p-2">{otvDoba.day}</td>
                            <td>
                              {otvDoba.from.substring(0, 5)} -{" "}
                              {otvDoba.to.substring(0, 5)}
                            </td>
                          </tr>

                          {/* volitelny druhy cas */}
                          {otvDoba.from_second && otvDoba.to_second && (
                            <tr>
                              <td></td>
                              <td>
                                {otvDoba.from_second.substring(0, 5)} -{" "}
                                {otvDoba.to_second.substring(0, 5)}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                )}
                <div
                  className="d-flex justify-content-center"
                  onClick={handleClose}
                >
                  <ButtonV2 text="Zavřít" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="container-fluid background-white">
        <div className="container container-background">
          <div className="d-flex flex-column flex-xl-row align-items-center align-items-xl-start justify-content-center ">
            <div className="col-12 col-xl-6 facility-card">
              <div className="heading d-flex align-items-center">
                <img src="/images/info-icon.png" alt="info-icon" />
                <h2>Základní informace</h2>
              </div>
              <div className="content">
                <BlocksRenderer
                  content={
                    Array.isArray(data?.data?.text) ? data.data.text : []
                  }
                  blocks={{
                    image: ({ image }) => (
                      <img
                        src={image.url}
                        alt={image.alternativeText}
                        className="blocks-renderer-img"
                      />
                    ),
                    list: ({ children, format }) =>
                      format === "unordered" ? (
                        <ul className="blocks-renderer-ul">{children}</ul>
                      ) : (
                        <ol className="blocks-renderer-ol">{children}</ol>
                      ),
                  }}
                ></BlocksRenderer>
              </div>
            </div>
            <div className="col-10 col-xl-4 facility-card">
              <div className="heading d-flex align-items-center">
                <img src="/images/time-icon.png" alt="info-time" />
                <h2>Provozní doba</h2>
              </div>
              <div className="content">
                <div className="d-flex flex-column flex-xl-row align-items-center align-items-xl-start justify-content-center">
                  {data.data.openingHours &&
                    data.data.openingHours.length > 0 && (
                      <table>
                        <tbody>
                          {data.data.openingHours.map((otvDoba) => (
                            <React.Fragment key={otvDoba.id}>
                              <tr
                                className={
                                  otvDoba.from_second === null &&
                                  otvDoba.to_second === null
                                    ? "last-row"
                                    : ""
                                }
                              >
                                <td className="text-start pe-5">
                                  {otvDoba.day}
                                </td>
                                <td>
                                  {otvDoba.from.substring(0, 5)} -{" "}
                                  {otvDoba.to.substring(0, 5)}
                                </td>
                              </tr>
                              {otvDoba.from_second !== null &&
                                otvDoba.to_second !== null && (
                                  <tr className="last-row">
                                    <td></td>
                                    <td>
                                      {otvDoba.from_second.substring(0, 5)} -{" "}
                                      {otvDoba.to_second.substring(0, 5)}
                                    </td>
                                  </tr>
                                )}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    )}
                </div>
                {/* <div className="section-divider mb-3 mt-3"></div>
                <div className="d-flex flex-column flex-md-row justify-content-between">
                  <h3>uredni hodiny</h3>
                  <table>
                    <tbody>
                      <tr>
                        <td>Pondělí</td>
                        <td>13.00-17.00</td>
                      </tr>
                      <tr>
                        <td>Úterý</td>
                        <td>13.00-17.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div> */}
              </div>
            </div>
          </div>
          <Lightbox
            plugins={[Download, Fullscreen, Thumbnails, Video]}
            open={index >= 0}
            close={() => setIndex(-1)}
            index={index}
            slides={mediaEdited}
          />
          <div className="container d-flex justify-content-around flex-wrap p-5">
            {data.data.photos?.map((slide, index) => (
              <img
                key={index}
                src={`${config.api}${slide.url}`}
                onClick={() => setIndex(index)}
                alt={slide.alternativeText}
                className="media-gallery"
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default SchoolFacilityPage;
